import { useState, forwardRef } from 'react';

import { Box } from '@mui/material';
import { PhoneInput, defaultCountries, parseCountry } from 'react-international-phone';
import 'react-international-phone/style.css';
import { IMAGE_PATHS } from '../../utils/imagePaths';
import { iconStyle } from '../../content/auth/login';
import ErrorMsg from '../ErrorMsg';
import { RequiredField } from '../../content/auth/signup';

const PhoneInputElement = forwardRef<any, any>(({
  mobileNo,
  emptyError,
  mobileNoError,
  validate,
  setCountryCode,
  showMobileError,
  disabled = false,
  label = 'Phone Number',
  required = true,
  validationType = 'mobile'
}, ref): any => {
  const [active, setActivate] = useState({ border: 1, borderColor: '#373E3840' });

  const disabledStyle = disabled
    ? {
      backgroundColor: '#f5f5f5',
      cursor: 'not-allowed',
      borderColor: 'gray'
    }
    : {};

  const customFlags = [
    {
      iso2: 'in',
      src: '/flags/in.svg',
    },
    {
      iso2: 'us',
      src: '/flags/us.svg',
    },
  ];

  const countries = defaultCountries.filter((countries) => {
    const country = parseCountry(countries);
    return customFlags.map((flag) => flag.iso2).includes(country.iso2);
  });

  return (
    <Box>
      <Box display={"flex"} alignItems={"center"} mb={1}>
        <Box sx={{ marginRight: "5px" }} width={20} display="flex" alignItems="center">
          <img src={IMAGE_PATHS.CALL} style={iconStyle} />
        </Box>
        <label>
          {label}
          {required ? <RequiredField>*</RequiredField> : null}
        </label>
      </Box >
      <Box sx={{ paddingBottom: validationType ? 0 : 2 }}>
        <Box sx={[{ borderRadius: 1 }, (mobileNo.length > 4) && mobileNoError || (required && ((mobileNo.length === 0) || emptyError)) ? { border: 1, borderColor: 'red' } : active, { ...disabledStyle },]}>
          <PhoneInput
            ref={ref}
            countries={countries}
            defaultCountry="us"
            value={mobileNo}
            onFocus={() => setActivate({ border: 2, borderColor: 'blue' })}
            onBlur={() => setActivate({ border: 1, borderColor: '#373E3840' })}
            dialCodePreviewStyleProps={{ style: { backgroundColor: 'transparent' } }}
            inputStyle={{ width: '100%', backgroundColor: 'transparent', height: 50, borderColor: 'transparent' }}
            countrySelectorStyleProps={{ style: { borderColor: 'transparent', paddingTop: 6, paddingLeft: 6, }, dropdownStyleProps: { style: { width: "260px" } } }}
            onChange={(inputValue, { country: { dialCode } }) => {
              setCountryCode(dialCode);
              validate(inputValue, validationType || "mobile");
              showMobileError(false);
            }}
            {...(disabled ? {
              disabled
            } : {})}
          />
        </Box>
        {(mobileNo.length > 4) && mobileNoError || (required && ((mobileNo.length === 0) && mobileNoError?.length || emptyError)) ? <ErrorMsg error={mobileNoError || emptyError} customStyle={{ marginTop: 0.5 }} /> : null}
      </Box>
    </Box>
  );
})

export default PhoneInputElement;
